import { Exception } from './exception';

/**
 * Exception thrown when a query parameter is constructed with a size limit, but a single query parameter alone cannot fit.
 */
export class QueryParameterTooLongException extends Exception {
  constructor(key: string, value: string, maximumLength: number) {
    super(
      `Parameter with key "${key}" has value "${value}", key and value combined exceeds maximum allowed length (${maximumLength}).`
    );
  }
}
